import React from 'react'
import './BaseSkeleton.css'

const Animation = () => {
  return (
    <div className="animation-wrapper">
      <div className="animation"></div>
    </div>
  )
}

export default Animation
